import { ITotalAmountOfSavings } from '../earnings/enum'
import { ELoanStatuses, LoansSummary } from '../loans/enum'

export interface IFormattedUser {
  id: string
  email: string
  phone: string
  is_active_2fa: boolean
  referral_code?: string
  created_at: string
  toaster_text?: string
  toaster_category?: string
  toaster_title?: string
  fallback_email?: string
  loans_disabled?: boolean
  kyc_verified?: string
  twitter_username?: string
  is_show_vip_banner?: boolean
  is_dynamic_loans_available?: boolean
  is_liquidation_portfolio_enabled?: boolean
}

export interface IUserSummary {
  loan: LoansSummary
  earn: ITotalAmountOfSavings
}

export interface IUserReferralsReward {
  exchanges: number
  loans: string
}

export enum EReferralRewardStatusLoan {
  NOT_READY = 'not_ready',
  READY = 'ready',
  REQUESTED = 'requested',
  COLLECTED = 'collected',
}

export interface IUserReferralsLoan {
  id: string
  status: ELoanStatuses
  closed_at: string
  created_at: string
  liquidated_at: string
  loan_amount: string
  profit: string
  referral_reward_request_id: string
  referral_reward_status: EReferralRewardStatusLoan
  user_id: string
  code: string
  network: string
}

export interface IUserReferrals {
  referral_code: string
  loans: IUserReferralsLoan[]
  reward: IUserReferralsReward
}

export interface ISendVipDto {
  email: string
  loan_amount: string
  loan_code: string
  loan_network: string
  collateral_code: string
  collateral_network: string
  name?: string
}

export type TransactionAccountType = 'loan' | 'saving' | 'wallet'

export enum ETransactionStatuses {
  PENDING = 'pending',
  CONFIRMING = 'confirming',
  PROCESSING = 'processing',
  FINISHED = 'finished',
  REJECTED = 'rejected',
  REFUNDED = 'refunded',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
}

export enum ETransactionTypes {
  DEPOSIT = 'deposit',
  REPAYMENT = 'repayment',
  INTEREST = 'interest',
  WITHDRAW = 'withdraw',
  EXCHANGE = 'exchange',
  PLEDGE = 'pledge',
  COLLATERAL = 'collateral',
  LOAN = 'loan',
  MONTHLY_INTEREST = 'monthly_interest',
  HOURLY_INTEREST = 'hourly_interest',
}

export interface ITransaction {
  account_type: TransactionAccountType
  account_id: number
  transaction_type: ETransactionTypes
  transaction_id: string
  hash: string
  from_currency: string
  from_network: string
  from_amount: string
  to_currency: string
  to_network: string
  to_amount: string
  status: ETransactionStatuses
  created_at: string
  from_address: string
  to_address: string
  from_extra_id: string
  to_extra_id: string
}

export interface IUserDevice {
  device: string
  location: {
    timezone: string
  }
  ip: string
  deviceType: 'desktop' | 'mobile' | 'unknown'
  date: Date
}

export interface ICancelTransactionDto {
  transaction_id: string
  transaction_type: ETransactionTypes
  account_type: string
}

export enum KycStatuses {
  VERIFIED = 'verified',
  NOT_VERIFIED = 'not_verified',
  VERIFICATION_IN_PROGRESS = 'verification_in_progress',
  VERIFICATION_REFUSED = 'verification_refused',
  VERIFICATION_REFUSED_WITH_RETRY = 'verification_refused_with_retry',
}

export interface IKycStatusResponse {
  status: KycStatuses
  retry: boolean
}
